(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery", "moment"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jQuery"), require("moment")) : factory(root["jQuery"], root["moment"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__21145__, __WEBPACK_EXTERNAL_MODULE__33192__) {
return 